import {TankReleaseCertificate} from "../getTankReleaseList";
import axios from "axios";
import {BaseResponse} from "../../../BaseResponse";

export async function putTankReleaseCertificate(tankReleaseId: string, tankReleaseCertificateId: string, tankReleaseCertificate: TankReleaseCertificate) {
    const response = await axios.put<BaseResponse<boolean>>(`/tank/release/${tankReleaseId}/certificate/${tankReleaseCertificateId}`, tankReleaseCertificate)

    return response.data
}